import Main from '@/views/administracion/adjudicaciones/Main.vue';
import Default from '@/views/administracion/adjudicaciones/Default.vue';

const auth = ['Adjudicaciones:ver'];
const scopes = ['Adjudicaciones:crear', 'Adjudicaciones:editar', 'Adjudicaciones:eliminar'];

const adjudicaciones = [
  {
    path: 'adjudicaciones',
    meta: {
      title: '',
      auth,
    },
    component: Main,
    children: [
      {
        name: 'adjudicaciones',
        path: '/',
        meta: {
          title: 'Adjudicaciones',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
    ],
  },
];

export default adjudicaciones;
